// src/components/MarketStatus.jsx
import React, { useEffect, useState } from "react";
import "./MarketStatus.css";
import { MARKET_SCHEDULE } from "../utils/marketCalendar";

function toET(date = new Date()) {
  return new Date(date.toLocaleString("en-US", { timeZone: "America/New_York" }));
}

function formatDuration(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
}

export default function MarketStatus() {
  const [state, setState] = useState({
    isOpen: false,
    label: "",
    countdown: "",
  });

  useEffect(() => {
    const tick = () => {
      const now = toET();
      const dateStr = now.toISOString().slice(0, 10);
      const day = now.getDay();

      // Weekend
      if (day === 0 || day === 6) {
        setState({
          isOpen: false,
          label: "Closed",
          countdown: "Opens Monday",
        });
        return;
      }

      // Holiday
      if (MARKET_SCHEDULE.holidays.includes(dateStr)) {
        setState({
          isOpen: false,
          label: "Closed",
          countdown: "Holiday",
        });
        return;
      }

      const schedule =
        MARKET_SCHEDULE.overrides[dateStr] ??
        MARKET_SCHEDULE.default;

      const [oH, oM] = schedule.open.split(":").map(Number);
      const [cH, cM] = schedule.close.split(":").map(Number);

      const openTime = new Date(now);
      openTime.setHours(oH, oM, 0, 0);

      const closeTime = new Date(now);
      closeTime.setHours(cH, cM, 0, 0);

      if (now >= openTime && now < closeTime) {
        setState({
          isOpen: true,
          label: "Open",
          countdown: `Closes in ${formatDuration(closeTime - now)}`,
        });
      } else if (now < openTime) {
        setState({
          isOpen: false,
          label: "Closed",
          countdown: `Opens in ${formatDuration(openTime - now)}`,
        });
      } else {
        setState({
          isOpen: false,
          label: "Closed",
          countdown: "Opens next trading day",
        });
      }
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="market-status">
      <div className="market-line">
        <span>Market</span>
        <span className={`status ${state.isOpen ? "open" : "closed"}`}>
          {state.label}
          <span className="status-dot" />
        </span>
      </div>
      <div className="market-sub">{state.countdown}</div>
    </div>
  );
}
